function formatPercentage(percentage: number) {
  return `${percentage.toFixed(1)}%`
}

export { formatPercentage }
